import { createFileRoute } from '@tanstack/react-router';
import DevicesAdmin from 'containers/DevicesAdmin';

export const Route = createFileRoute('/_authenticated/devicesAdmin')({
  validateSearch: (
    search: Record<string, unknown>
  ): { resourceId?: string } => ({
    resourceId:
      typeof search.resourceId === 'string' ? search.resourceId : undefined,
  }),
  component: DevicesAdmin,
});
